import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig, countries, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the FilterLandingReportView.
 * @extends JetView
 */
export default class FilterLandingReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row', // CSS class for styling
                    responsive: 'a1', // Responsive behavior
                    cols: [
                        {
                            view: 'text', // Text input for date range
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange', // CSS class for styling
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'), // Default value for date range
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the input
                            labelPosition: 'top', // Position of the label
                            minWidth: 200, // Minimum width of the input
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'datepicker', // Datepicker component
                            name: 'Date',
                            id: 'Date',
                            stringResult: true, // Return date as string
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'), // Default date value
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar', // Suggestion type
                                body: {
                                    maxDate: new Date(), // Maximum selectable date
                                },
                            },
                        },
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            minWidth: 200,
                            localId: 'regions:combo', // Local ID for referencing
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Template for displaying country flags
                                        );
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            hidden:
                                devConfig.getCountryReport() || // Conditional visibility based on config
                                !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry', // CSS class for styling
                        },
                        {
                            view: 'richselect', // Second dropdown for country selection
                            name: 'CountrySelect2',
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: profile.Settings.ReportCountry, // Default value from profile settings
                            readonly: true, // Read-only field
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value; // Template for displaying country flags
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            hidden:
                                !devConfig.getCountryReport() || // Conditional visibility based on config
                                !devConfig.getPermAction('filterByCountry', 'Add'),
                        },
                        {
                            view: 'text', // Text input for user ID
                            name: 'UserId',
                            type: 'number', // Input type
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'),
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'), // Placeholder text
                            invalidMessage: _('User ID is required'), // Validation message
                        },
                    ],
                },
            ],
        };
        const left2 = {
            margin: 5,
            id: 'a2',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a2',
                    cols: [
                        {
                            view: 'text', // Text input for partner bonus ID
                            name: 'PartnerBonusId',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-id'></span>" + _('Partner Bono Id'),
                            labelPosition: 'top',
                            placeholder: _('Bono ID'), // Placeholder text
                            invalidMessage: _('Partner Bonus Id is required'), // Validation message
                        },
                        {
                            view: 'richselect', // Dropdown for bonus type selection
                            name: 'BonusType',
                            minWidth: 200,
                            localId: 'bonusTypes:combo',
                            label: _('Tipo'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '', value: _('Todos') }, // Option for all types
                                { id: '2', value: _('Deposito') }, // Deposit type
                                { id: '3', value: _('No Deposito') }, // Non-deposit type
                                { id: '6', value: _('FreeBet') }, // FreeBet type
                            ],
                        },
                        {
                            view: 'richselect', // Dropdown for bonus state selection
                            name: 'State',
                            minWidth: 200,
                            localId: 'bonusStates:combo',
                            label: "<span class='icon-state'></span>" + _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                {
                                    id: '',
                                    value: _('Todos'), // Option for all states
                                },
                                {
                                    id: 'A',
                                    value: _('Activo'), // Active state
                                },
                                {
                                    id: 'I',
                                    value: _('Inactivo'), // Inactive state
                                },
                                {
                                    id: 'P',
                                    value: _('Pendiente'), // Pending state
                                },
                                {
                                    id: 'R',
                                    value: _('Redimido'), // Redeemed state
                                },
                                {
                                    id: 'E',
                                    value: _('Expirado'), // Expired state
                                },
                                {
                                    id: 'L',
                                    value: _('Libre'), // Free state
                                },
                            ],
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container', // CSS class for styling
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section with filters
                },
            ],
        };
        const upper_section2 = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Second left section with additional filters
                },
            ],
        };
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true, // Allows multiple sections to be expanded
                    view: 'accordion', // Accordion component
                    css: 'betShop', // CSS class for styling
                    collapsed: true, // Initial state collapsed
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Header for advanced filters
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Body containing upper section 2
                            },
                        },
                    ],
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'),
                    width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                        $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect); // Reset country selection
                        $$('Datepicker').setValue(''); // Clear datepicker
                    },
                },
                {
                    id: 'consultDesk',
                    view: 'button', // Button to consult/filter data
                    value: _('Consultar'),
                    hotkey: 'enter', // Hotkey for the button
                    type: 'form',
                    width: screen == 'small' ? 0 : 100,
                    click: () => {
                        let filterdata = this.getRoot().getValues(); // Get form values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country based on profile settings
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date if not applicable
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if applicable
                            }
                        }
                        this.app.callEvent('bonusReport:filter', [filterdata]); // Trigger filter event
                        $$('b1').collapse(); // Collapse the accordion section
                        $$('a5').scrollTo(100, 0); // Scroll to a specific position
                    },
                },
            ],
        };
        const buttons2 = {
            rows: [
                {
                    padding: 10,
                    cols: [
                        {
                            view: 'button', // Button to add mass bonus
                            value: _('Añadir bono masivo'),
                            type: 'form',
                            hidden: !devConfig.getPermAction('bonusBalanceAddMassive', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-bonusBalanceAddMassive', // CSS class for styling
                            click: () => {
                                this.app.callEvent('addBonusBalance2:button', [{}]); // Trigger event to add mass bonus
                            },
                        },
                        {
                            view: 'button', // Button to add bonus to balance
                            value: _('Añadir bono a saldo'),
                            type: 'form',
                            hidden: !devConfig.getPermAction('bonusBalanceAdd', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-bonusBalanceAdd', // CSS class for styling
                            click: () => {
                                this.app.callEvent('addBonusBalance:button', [{}]); // Trigger event to add bonus to balance
                            },
                        },
                    ],
                },
                {
                    padding: 10,
                    cols: [
                        {
                            view: 'button', // Button to clear the second form
                            value: _('Limpiar'),
                            click: () => {
                                $$('myForm2').setValues(
                                    $$('myForm2').getCleanValues(), // Reset second form values
                                );
                                $$('CountrySelect').setValue($$('myForm2').getCleanValues().CountrySelect); // Reset country selection
                                $$('Datepicker').setValue(''); // Clear datepicker
                            },
                        },
                        {
                            view: 'button', // Button to consult/filter data from the second form
                            value: _('Consultar'),
                            hotkey: 'enter', // Hotkey for the button
                            type: 'form',
                            click: () => {
                                const filterdata = $$('myForm2').getValues(); // Get second form values
                                if (devConfig.getCountryReport()) {
                                    filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country based on profile settings
                                }
                                delete filterdata['CountrySelect2']; // Remove unnecessary field
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove date if not applicable
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove datepicker if applicable
                                    }
                                }
                                this.app.callEvent('bonusReport:filter', [
                                    filterdata, // Trigger filter event
                                ]);
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion component
                    css: 'betShop', // CSS class for styling
                    collapsed: true, // Initial state collapsed
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for filters
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Body containing upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view
            scroll: 'xy', // Scroll in both directions
            body: {
                padding: 10,
                rows: [upper_section, accordion_section], // Body containing upper section and accordion
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true, // Fullscreen mode
            head: {
                view: 'toolbar', // Toolbar for the popup
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Title label
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on click
                        },
                    },
                ],
            },
            modal: true, // Modal window
            position: 'center', // Centered position
            body: {
                view: 'form', // Form inside the popup
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Rows containing accordion and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
                },
            },
        });
        return {
            view: 'form', // Main form view
            id: 'myForm',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section1 // Conditional rendering based on screen size
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object passed to the init method.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide date input if not applicable
                $$('Datepicker').show(); // Show datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show date input
                    $$('Datepicker').hide(); // Hide datepicker
                }
            }
        });
    }
}

// FILE DOCUMENTED
